<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import planCommonMixin from '@/plans/EVENT_SAAS/mixin';
import { sortBy } from 'lodash';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { isEventSaasOrEventSassCore } from '@/common/constants';
import AltProratedPlanUser from '@/views/config/shopping-cart/prorated/plan-user.vue';
import AltProratedPlanPrice from '@/views/config/shopping-cart/prorated/plan-price.vue';
import AltProratedPlanPeriod from '@/views/config/shopping-cart/prorated/plan-period.vue';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  mixins: [mixin, planCommonMixin],
  components: {
    AltProratedPlanUser,
    AltProratedPlanPrice,
    AltProratedPlanPeriod,
  },
  computed: {
    showRemove() {
      // Hack: plan remove logic places in mx_remove when the user is from shopping bag
      if(isFromShoppingCart()) {
        return true;
      }
      const fromPlanType = getPlanTypeByCategory(pageConfig.plan);
      return fromPlanType !== this.planType;
    },
    attendeesName() {
      return isEventSaasOrEventSassCore(this.planType) ? this.$t('billing.events.attendees', ['']) : this.$t('billing.participants');
    }
  },
  methods: {
    renderConsumptionPlanList(list = []) {
      if (!list.length) return;
      const plan = list[0];

      return <div class="opc-cart-item" key={plan.plan_code} >
        {this.mx_title(`${this.$t(plan.typeNameKey)} ${this.$t('billing.events.ppa.title')}`, this.mx_price(plan), plan?.plan_code)}
        {this.mx_discount(plan.plan_code)}
        {this.renderAttendeeDesc(plan)}
        {this.mx_edit(plan)}
        {this.showRemove ? this.mx_remove(plan) : null}
      </div>
    },
    renderSaasPlanList(list = []) {
      if (!list.length) return;
      const targetItem = list.some(plan => !!plan.isOnlineFreeTrial)
      return <div class="opc-cart-item">
        {/* FREE TRIAL - Specific UI for free trial */}
        { targetItem?
          this.mx_freeTrialTitle(this.title, undefined, list?.[0]?.parent_category) : this.mx_main_title(this.title, undefined, list?.[0]?.parent_category)}
        {sortBy(list, 'capacity').map((plan) => {
          return this.renderSaasPlan(plan);
        })}
      </div>
    },
    renderSaasPlan(plan) {
      if(!plan || !plan.cartInfo) return null;
      const quantity = plan.cartInfo.selected_number;
      {/* FREE TRIAL - Specific UI for free trial */}
      if(!!plan.isOnlineFreeTrial && !!plan.trialDays) {
        return (
            <div key={plan.plan_code} >
              {this.mx_license(quantity, this.$t('billing.planform.unit.license'))}
              {this.mx_freeTrialDesc(plan.trialDays)}
              {this.mx_cycle(plan.billing_cycle)}
              {this.mx_edit(plan)}
              {this.showRemove ? this.mx_remove(plan) : null}
            </div>
        )
      }
      return (
        <div key={plan.plan_code} >
          {this.mx_subTitle(`${plan.capacity} ${this.attendeesName}`, <AltProratedPlanPrice type={plan.type} code={plan.plan_code}>{this.$money(this.mx_price(plan))}</AltProratedPlanPrice>, plan?.plan_code)}
          {this.mx_discount(plan.plan_code)}
          <AltProratedPlanUser type={plan.type} code={plan.plan_code}>{this.mx_license(quantity)}</AltProratedPlanUser>
          {this.mx_cycle(plan.billing_cycle)}
          <AltProratedPlanPeriod type={plan.type} code={plan.plan_code} />
          {this.mx_edit(plan)}
          {this.showRemove ? this.mx_remove(plan) : null}
        </div>
      );
    },
    renderAttendeeDesc(plan) {
      return <p class="opc-cart-item__attendee">{plan.capacity} {this.attendeesName}</p>
    },
    $renderPrice() {
      const saasPlans = this.mx_plans.filter((p) => p.isSaas);
      const ppaPlans = this.mx_plans.filter((p) => p.isPPA);

      return <div>
        {this.renderSaasPlanList(saasPlans)}
        {this.renderConsumptionPlanList(ppaPlans)}
      </div>
    },
    $renderAgreement() {
      return <div class="opc-cart-item__text"></div>;
    },
  },
};
</script>

<style lang="scss">
.opc-cart-item {
  &__attendee {
    color: #515079;
    font-family: Almaden Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    text-transform: capitalize;
  }

  &__unit {
    color: #515079;
    font-family: Almaden Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
  }
}
</style>
